import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadInternationalCurrencies,
  loadInternationalCurrenciesFailure,
  loadInternationalCurrenciesSuccess,
  toggleInternationalCurrenciesLoading,
} from './international-currencies.actions';
import {
  selectInternationalCurrenciesList,
  selectInternationalCurrenciesLoading,
} from './international-currencies.selectors';

@Injectable()
export class InternationalCurrenciesEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);
  private store = inject(Store);

  constructor() {}

  loadInternationalCurrencies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadInternationalCurrencies),
      withLatestFrom(
        this.store.select(selectInternationalCurrenciesLoading),
        this.store.select(selectInternationalCurrenciesList),
      ),
      filter(([action, isLoading, list]) => !isLoading && (!list || list.length === 0)),
      tap(() => this.store.dispatch(toggleInternationalCurrenciesLoading({ isLoading: true }))),
      switchMap(() =>
        this.referenceService.referenceLookupGetInternationalCurrenciesGet().pipe(
          map((response) => loadInternationalCurrenciesSuccess({ internationalCurrencies: response.result || [] })),
          catchError((error) => of(loadInternationalCurrenciesFailure({ error }))),
        ),
      ),
    ),
  );
}
